import React, { useState, useEffect } from 'react';
import { MessageCircle, Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false); // Close menu after navigation
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-[#003847]/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            {/* Custom Logo Circle */}
            <div className="w-12 h-12 bg-[#CFAE70] rounded-full flex items-center justify-center shadow-lg">
              <span className="text-white text-2xl font-bold">B</span>
            </div>
            <div className="flex flex-col">
              <span
                className={`text-2xl font-bold tracking-tight transition-colors ${
                  scrolled ? 'text-[#003847]' : 'text-white'
                }`}
              >
                BOCADIA
              </span>
              <span className="text-xs font-medium text-[#CFAE70]">
                La pausa que tu día merece
              </span>
            </div>
          </div>

          {/* Navigation Links - Desktop */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('solucion')}
              className={`text-sm font-medium transition-colors hover:text-[#CFAE70] ${
                scrolled ? 'text-[#003847]' : 'text-white'
              }`}
            >
              Solución
            </button>
            <button
              onClick={() => scrollToSection('beneficios')}
              className={`text-sm font-medium transition-colors hover:text-[#CFAE70] ${
                scrolled ? 'text-[#003847]' : 'text-white'
              }`}
            >
              Beneficios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className={`text-sm font-medium transition-colors hover:text-[#CFAE70] ${
                scrolled ? 'text-[#003847]' : 'text-white'
              }`}
            >
              Nosotros
            </button>
            <a
              href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-2.5 bg-[#CFAE70] text-white font-semibold rounded-lg hover:bg-[#B89A5F] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <MessageCircle className="w-4 h-4" />
              Contáctanos
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`flex items-center gap-2 px-4 py-2 transition-all ${
                scrolled ? 'text-[#003847] hover:text-[#CFAE70]' : 'text-white hover:text-[#CFAE70]'
              }`}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-[#003847] shadow-lg border-t border-white/10">
            <div className="flex flex-col p-4 space-y-4">
              <button
                onClick={() => scrollToSection('solucion')}
                className="text-white text-left py-3 px-4 hover:bg-white/10 rounded-lg transition-colors"
              >
                Solución
              </button>
              <button
                onClick={() => scrollToSection('beneficios')}
                className="text-white text-left py-3 px-4 hover:bg-white/10 rounded-lg transition-colors"
              >
                Beneficios
              </button>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="text-white text-left py-3 px-4 hover:bg-white/10 rounded-lg transition-colors"
              >
                Nosotros
              </button>
              <a
                href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-[#CFAE70] text-white font-semibold rounded-lg hover:bg-[#B89A5F] transition-all"
              >
                <MessageCircle className="w-4 h-4" />
                Contáctanos
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
